import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const FlexBox = ({ basis, direction, grow, shrink, wrap, children, ...rest }) => {
  const sanitizedRest = useMemo(() => {
    // eslint-disable-next-line no-unused-vars
    const { display, flexBasis, flexDirection, flexGrow, flexShrink, flexWrap, ...others } = rest;
    return others;
  }, [rest]);

  return (
    <Box display='flex' flexBasis={basis} flexDirection={direction} flexGrow={grow} flexShrink={shrink} flexWrap={wrap} {...sanitizedRest}>
      {children}
    </Box>
  );
};

FlexBox.propTypes = {
  basis: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  direction: PropTypes.string,
  grow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shrink: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wrap: PropTypes.string,
  children: PropTypes.node
};

export default FlexBox;
